export const isDevelopment = process.env.REACT_APP_CHAIN_ID === '97'
